import create from 'zustand';
import { Media } from '../types';

type MediaStore = {
  sm: boolean,
  md: boolean,
  lg: boolean,
  xl: boolean,
  set: (sm: boolean, md: boolean, lg: boolean, xl: boolean) => void,

  media: Media,
  setMedia: (media: Media) => void
}

const useMediaStore = create<MediaStore>(set => ({
  sm: false,
  md: false,
  lg: false,
  xl: false,
  set: (sm, md, lg, xl) => set(() => ({ sm, md, lg, xl })),

  media: "xs",
  setMedia: media => set(() => ({ media }))
}));

export default useMediaStore;